var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1405 2.00015H16C17.2426 2.00015 18.25 3.00751 18.25 4.25015V19.7501C18.25 20.9928 17.2426 22.0001 16 22.0001H8C6.75736 22.0001 5.75 20.9928 5.75 19.7501V4.25015C5.75 3.00751 6.75736 2.00015 8 2.00015H9.85947C9.8694 1.99995 9.87933 1.99995 9.88924 2.00015H14.1108C14.1207 1.99995 14.1306 1.99995 14.1405 2.00015ZM9.42493 3.50015H8C7.58579 3.50015 7.25 3.83593 7.25 4.25015V19.7501C7.25 20.1644 7.58579 20.5001 8 20.5001H16C16.4142 20.5001 16.75 20.1644 16.75 19.7501V4.25015C16.75 3.83593 16.4142 3.50015 16 3.50015H14.5751L14.0368 4.50974C13.9065 4.75419 13.652 4.90689 13.375 4.90689H10.625C10.348 4.90689 10.0935 4.75419 9.96318 4.50974L9.42493 3.50015Z",
    fill: "#323544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.bdc3d7f6c58831416b45f743f2615486.svg";
export { ForwardRef as ReactComponent };